// Indicates the start of the code that should be excluded from the Custom Code execution.
const EXCLUDE_CODE_COMMENT_START = '<!-- EXCLUDE FROM PREVIEW: START -->';
// Indicates the end of the code that should be excluded from the Custom Code execution.
const EXCLUDE_CODE_COMMENT_END = '<!-- EXCLUDE FROM PREVIEW: END -->';

/**
 * This function filters out part of the HTML code that is provided as part of one of the custom code values that is between specific HTML comments.
 * We added this functionality to allow our users to make sure that they have a way to exclude some of the code of being executed in the when Custom Code
 * is on the Designer App (for example, in Preview mode). In this way, for example custom analytics code will be not executed is places between this HTML
 * comments and user is in the Preview mode with Custom Code enabled.
 */
export const excludeCommentedCode = (html: string) => {
  let result = html;
  let startIndex = result.indexOf(EXCLUDE_CODE_COMMENT_START);

  while (startIndex !== -1) {
    const endIndex = result.indexOf(EXCLUDE_CODE_COMMENT_END, startIndex);

    if (endIndex === -1) {
      // If there's no matching end comment, break the loop
      break;
    }

    // Remove the commented section, including the comments
    result =
      result.slice(0, startIndex) +
      result.slice(endIndex + EXCLUDE_CODE_COMMENT_END.length);

    // Look for the next start comment
    startIndex = result.indexOf(EXCLUDE_CODE_COMMENT_START);
  }

  return result;
};
